import { AavoIconButton, AavoIconButtonProps } from "./AavoIconButton";
import { faTimes } from "@fortawesome/pro-regular-svg-icons";

export const CancelButton = (props: Omit<AavoIconButtonProps, "icon">) => {
	return <AavoIconButton icon={faTimes} {...props} />;
};
